import { useQuery } from 'react-query';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { getKeyAchievements as queryFn } from 'api/endPoints/getKeyAchievements';
import { ISingleSmallCardResponse } from 'api/queries/getListFilteredCards.query';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetKeyAchievementsData = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['keyAchievementsDataTable', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.latestVersionId) && Boolean(params.compareVersionId),
    });
};

export interface QueryParams extends NarrativeRequest {
    compareVersionId: number | undefined;
    filterName?: string;
    latestVersionId: number | undefined;
    timePeriod: number;
    filters?: any;
}

interface QueryResponse {
    title: string;
    periodItemsList: {
        id: string;
        summary: null;
        itemsList: {
            order: number;
            latestVersion: {
                predecessors: number;
                successors: number;
                startDate: number;
                finishDate: number;
                cardBoardViewResponse: ISingleSmallCardResponse;
                id: number;
                activityStatus: string;
                taskVersionHashCode: string;
                trackedActivity: boolean;
                activityId: string;
                activityName: string;
                criticalityScore: number;
                float: number | null;
                cardDetails: string | null;
                duration: number;
            };
            comparedVersion: {
                predecessors: number;
                successors: number;
                startDate: number;
                finishDate: number;
                id: number;
                activityStatus: string;
                taskVersionHashCode: string;
                trackedActivity: boolean;
                activityId: string;
                criticalPath: boolean;
                activityName: string;
                criticalityScore: number;
                float: number | null;
                cardDetails: string | null;
                duration: number;
            } | null;
            changeMap: {
                successors: number;
                predecessors: number;
                startDate: number;
                criticalPath: null;
                criticalityScore: number;
                finishDate: number;
                float: number | null;
                duration: number | null;
                activityStatus: string;
            } | null;
        }[];
    }[];
    info: IToolTip;
    typeId: null;
}
